import React from "react";
import  "../PrePayment.scss";

export class PrePaymentWrapperIcons extends React.Component {
    render() {
        return <div id="payment_page_icons">
            {this.props.children}
        </div>;
    }
}